import React from 'react';

interface EditableSectionProps {
  id: string;
  title: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  isDarkMode: boolean;
}

const EditableSection: React.FC<EditableSectionProps> = ({
  id,
  title,
  value,
  onChange,
  placeholder,
  rows = 5,
  isDarkMode,
}) => {
  const titleClasses = isDarkMode ? 'text-slate-200' : 'text-slate-800';
  const textareaClasses = isDarkMode
    ? 'border-slate-700 bg-slate-950/70 text-slate-100 placeholder:text-slate-500 focus:border-emerald-400/60 focus:ring-emerald-400/20'
    : 'border-orange-200 bg-white text-slate-900 placeholder:text-slate-400 focus:border-emerald-500/50 focus:ring-emerald-500/20';
  const minHeightClass = rows <= 2 ? 'min-h-[3rem]' : rows <= 3 ? 'min-h-[4.5rem]' : 'min-h-[7rem]';

  return (
    <div className="space-y-2">
      <label htmlFor={id} className={`block text-sm font-semibold tracking-wide ${titleClasses}`}>
        {title}
      </label>
      <textarea
        id={id}
        rows={rows}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={`${minHeightClass} w-full resize-y rounded-2xl border px-3 py-2.5 text-sm leading-6 outline-none transition-colors focus:ring-2 ${textareaClasses}`}
      />
    </div>
  );
};

export default EditableSection;
